/**
 * Ladezustand eines Routen-Gates (#699).
 *
 * Zwei Gates liegen hintereinander auf dem Weg in jede geschuetzte Route:
 * `ProtectedRoute` prueft die Anmeldung, `RequireApplication` danach die
 * Anwendungszuweisung. An beiden Stellen stand ein nacktes `Loading...` —
 * unformatiert auf dem Browser-Hintergrund und englisch unabhaengig von der
 * eingestellten Sprache. Fuer einen Communicator-Nutzer war das der erste
 * Eindruck nach der Anmeldung.
 *
 * Der Spinner allein traegt die Aussage NICHT: lucide setzt `aria-hidden` auf
 * sein SVG, ein Screenreader faende also eine leere Seite vor — schlechter als
 * das alte `Loading...`. Deshalb `role="status"` samt `aria-live` wie in
 * `AppContainer`, und der Text als `sr-only`-Inhalt statt als `aria-label`:
 * eine Live-Region wird ueber ihren INHALT angesagt. Der Schluessel dafuer
 * existiert bereits (`common.loading`), es kommt keiner hinzu — und anders als
 * frueher ist die Ansage damit uebersetzt.
 *
 * `h-screen` statt `h-full`: hier gibt es keinen Wirt, der eine Hoehe vorgibt —
 * mit `h-full` fiele der Container auf 0 zusammen und der Spinner waere
 * unsichtbar. Aus demselben Grund traegt dieser Zustand `app-surface` selbst,
 * anders als die Suspense-Fallbacks der Standalone-Seiten, die bereits in einer
 * gesetzten Flaeche stehen.
 */
import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function RouteLoading() {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      aria-live="polite"
      className="app-surface flex h-screen w-full items-center justify-center"
    >
      <Loader2 className="h-6 w-6 animate-spin motion-reduce:animate-none text-[var(--text-secondary)]" />
      <span className="sr-only">{t('common.loading')}</span>
    </div>
  )
}
